// src/pages/Harassment.js
import React from 'react';

const Harassment = () => {
  return (
    <div className="page harassment-page">
      <section className="page-header">
        <div className="container">
          <h1>Anti-harassment</h1>
          <p>Safer spaces at Integralis events</p>
        </div>
      </section>

      <section className="content-section">
        <div className="container">

          <div className="info-card mb-2">
            <h3>Harassment contact form</h3>
            <p>
              If you were the victim of, or observed, behaviour that goes against HYY&apos;s safer
              space policies, the university&apos;s code of conduct, or that you otherwise feel
              qualifies as harassment, you can contact our anti-harassment officers. Integralis
              strongly condemns all forms of harassment and takes every report seriously.
            </p>
            <p>
              <strong>Anonymous form:</strong>
            </p>
            <p>
              <a
                href="https://forms.office.com/e/LVqviMyzb4"
              >
                Harassment contact form
              </a>
            </p>
          </div>

          <div className="info-card">
            <h3>Direct contact persons</h3>
            <p>
              You can also contact our anti-harassment officers directly by email or Telegram.
            </p>
            <ul>
              <li>
                <strong>Aykaç Çiçek</strong><br />
                Email: cicek.aykac@helsinki.fi<br />
                Telegram: @cicekaa
              </li>
              <li>
                <strong>Arjun Menon Tiwari </strong><br />
                Email: arjun.tiwari@helsinki.fi<br />
                Telegram: @arjmt
              </li>                
              <li>
                <strong>Hendrik Erik Raidal</strong><br />
                Email: hendrik.raidal@helsinki.fi<br />
                Telegram: @hraidal
              </li>
                          
            </ul>
          </div>

        </div>
      </section>
    </div>
  );
};

export default Harassment;

